<template>
  <div>
    <template v-for="item in treeData" :key="item.value">
      <el-sub-menu
        v-if="item.children && item.children.length > 0 && currentDepth < maxDepth"
        :index="item.value"
      >
        <template #title>
          <span>{{ item.label }}</span>
        </template>
        <ProductMenu
          :tree-data="item.children"
          :isRoot="false"
          :current-depth="currentDepth + 1"
          :max-depth="maxDepth"
        ></ProductMenu>
      </el-sub-menu>
      <el-menu-item v-else :index="item.value">
        <span>{{ item.label }}</span>
      </el-menu-item>
      <div v-if="item.brand" class="promenujian"></div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    treeData: {
      type: Object,
    },
    isRoot: {
      type: Boolean,
      default: true,
    },
    currentDepth: {
      type: Number,
      default: 1, // 默认当前深度为1
    },
    maxDepth: {
      type: Number,
      default: 5, //默认最大深度为5
    },
  },
});
</script>
<style>
.promenujian {
  width: 90%;
  margin: auto;
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
}
</style>
